import api from '@/utils/api'

const safeFilePart = (value) => String(value || '')
  .trim()
  .replace(/[\\/:*?"<>|]+/g, '-')
  .replace(/\s+/g, '_')
  .slice(0, 70)

export const downloadWaybillPdf = async (lesson) => {
  if (!lesson?.id) throw new Error('Lesson id is required')

  const response = await api.get(`/waybills/${lesson.id}`, {
    responseType: 'blob',
    headers: { Accept: 'application/pdf' }
  })

  const contentType = String(response.headers?.['content-type'] || '')
  if (!contentType.includes('application/pdf')) {
    throw new Error('Server did not return a PDF')
  }

  const blobUrl = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = `Жол_парағы_${safeFilePart(lesson.studentName || 'оқушы')}_${lesson.dateIso || 'күні'}.pdf`
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(blobUrl), 30_000)
}
